import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';
import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';

const getArticlesBreadcrumbs = (query?: IQueryParams): IBreadcrumb[] => ([
  getMarketOverviewBreadcrumbsRoute(query),
  {
    title: 'Commentary & Deal Flow',
    isActive: true,
  },
]);

export default getArticlesBreadcrumbs;
